var render = function render(){var _vm=this,_c=_vm._self._c;return _c('design-2021-files-table-component',{attrs:{"user-id":_vm.authId,"project-id":_vm.projectId,"is-student":_vm.authIsStudent}})
}
var staticRenderFns = []

export { render, staticRenderFns }